import { DEFAULT_DATE_FORMAT, getDate } from '../../../utils/dates';
import { isEmpty, ValidationResult } from '../../../utils/getValidator';

export type BirthDateValidation = { required?: boolean; minAge?: number };

const getBirthDateValidator =
  ({ required, minAge = 0 }: BirthDateValidation) =>
  (value: string): ValidationResult => {
    if (!required && isEmpty(value)) {
      return undefined;
    } else if (isEmpty(value)) {
      return { key: 'required' };
    } else if (value === 'invalid') {
      return { key: 'invalid' };
    }

    const now = getDate();
    const date = getDate(value, DEFAULT_DATE_FORMAT, true);
    const age = now.diff(date, 'year');
    if (age > 120 || age < 0) {
      return { key: 'invalid' };
    } else if (age < minAge) {
      return { key: 'minAge', values: { minAge } };
    } else {
      return undefined;
    }
  };

export default getBirthDateValidator;
